module.exports = __webpack_public_path__ + "static/img/deskbg_100.a627a52f.jpg";